
import { Component, InjectReactive, Prop, Vue } from "vue-property-decorator";
import Amount from "@/components/balance/Amount.vue";
import CurrencyIcon from "@/components/balance/CurrencyIcon.vue";
import { BALANCE_RATES_SYMBOL } from "@/constants";

// Качество "(Factory New)" в конце названия или перед фазой доплера:
// "★ Gut Knife | Doppler (Factory New) - Phase 2"
const EXTERIOR_REGEXP = /\s*\(([^()]+)\)(?= - (?:Phase [1-4]|Ruby|Sapphire|Black Pearl|Emerald)$|$)/;

// "StatTrak™ M4A4 | Turbine", у ножей после звезды: "★ StatTrak™ Karambit | ..."
const STATTRAK_REGEXP = /StatTrak™\s*/;

// Цвет свечения, если редкость не пришла (как у "Base Grade")
const DEFAULT_RARITY_RGB = "176, 195, 217";

@Component({
  components: {
    CurrencyIcon,
    Amount
  }
})
export default class SteamItem extends Vue {
  @InjectReactive(BALANCE_RATES_SYMBOL)
  public balanceRates: any;

  @Prop() _id: string | undefined;
  @Prop() name: string | undefined;
  @Prop() price: number | undefined;
  @Prop() image: string | undefined;
  @Prop() rarity: string | undefined;
  @Prop() rarityColor: string | undefined;
  @Prop() steamBotId: string | undefined;
  @Prop() stickers: { name: string; image: string }[] | undefined;

  @Prop() selected: boolean | undefined;
  @Prop() disabled: boolean | undefined;
  @Prop() showUsdPrice: boolean | undefined;
  // Карточка выше, название всегда видно под ценой (вместо подсказки при наведении)
  @Prop({ default: false }) showName: boolean | undefined;

  get quality() {
    if (!this.name) {
      return null;
    }

    const quality = this.name.match(EXTERIOR_REGEXP);
    return quality ? quality[1].replace(/[^A-Z]/g, "") : null;
  }

  // "#5e98d9" -> "94, 152, 217" для rgba(var(--rarity-rgb), alpha) в стилях
  get rarityRgb() {
    let hex = (this.rarityColor || "").replace("#", "");
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map(c => c + c)
        .join("");
    }
    if (!/^[0-9a-f]{6}$/i.test(hex)) {
      return DEFAULT_RARITY_RGB;
    }

    return [0, 2, 4].map(i => parseInt(hex.substr(i, 2), 16)).join(", ");
  }

  get isStatTrak() {
    return !!this.name && STATTRAK_REGEXP.test(this.name);
  }

  // Без качества и без StatTrak™ — они показаны бейджами в углу
  get nameWithoutQuality() {
    if (!this.name) {
      return null;
    }

    return this.name.replace(EXTERIOR_REGEXP, "").replace(STATTRAK_REGEXP, "");
  }
}
